module.exports = __webpack_public_path__ + "static/media/laxmirajW2.376238f4.png";